export default {
    VALOR_TOTAL: 'Valor Total',
    VALOR_UNITARIO: 'Valor Unitário'
}
